export const notificationsConstants = {
  INDIVIDUAL_NOTIFICATION: "INDIVIDUAL_NOTIFICATION",
  GROUP_NOTIFICATION: "GROUP_NOTIFICATION",
  GROUP_NOTIFICATION_SUCCESS: "GROUP_NOTIFICATION_SUCCESS",
  GROUP_NOTIFICATION_FAILURE: "GROUP_NOTIFICATION_FAILURE",
  GROUP_NOTIFICATION_BODY: "GROUP_NOTIFICATION_BODY",
  GROUP_NOTIFICATION_RESET: "GROUP_NOTIFICATION_RESET"
};
